export const LOAD_ACTIVITY = 'load_activity'
export const ADD_ACTIVITY = 'add_activity'

export function loadActivity () {
  return {
    type: LOAD_ACTIVITY,
    activities: []
  }
}

export function addActivity (activities) {
  return {
    type: ADD_ACTIVITY,
    activities
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profileActivityAction.js